import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader, SectionLabel } from "@/components/shared";
import { FadeUp } from "@/components/motion/Reveal";
import { getBlog } from "@/lib/api";
import { ASSETS } from "@/lib/assets";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { getBlog().then(setPosts).catch(() => {}); }, []);

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div data-testid="blog-page">
      <PageHeader
        testId="blog-header"
        label="Read"
        title={<>The <span className="text-wutn">Journal</span></>}
        subtitle="Teaching, encouragement, and calls to action from Wake-Up The Nation."
        image={ASSETS.founderWhiteWide}
      />

      <section className="bg-black py-16 md:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          {featured && (
            <FadeUp>
              <Link to={`/blog/${featured.slug}`} data-testid={`blog-featured-${featured.slug}`} className="group grid lg:grid-cols-12 gap-8 items-center border-b border-white/10 pb-16 mb-16">
                <div className="lg:col-span-6 overflow-hidden">
                  <img src={ASSETS.preachingStage} alt={featured.title} className="w-full h-72 md:h-96 object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="lg:col-span-6">
                  <span className="text-xs uppercase tracking-[0.25em] text-wutn font-bold">{featured.category} · Featured</span>
                  <h2 className="mt-4 font-display uppercase text-4xl md:text-6xl leading-[0.9] group-hover:text-wutn transition-colors">{featured.title}</h2>
                  <p className="mt-5 text-zinc-400 text-lg">{featured.excerpt}</p>
                  <p className="mt-6 text-sm text-zinc-500">{featured.author} · {new Date(featured.date).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })} · {featured.read_time}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-white group-hover:text-wutn font-cond uppercase tracking-wider text-sm transition-colors">Read Article <ArrowRight className="h-4 w-4" /></span>
                </div>
              </Link>
            </FadeUp>
          )}

          <SectionLabel className="mb-10">More Articles</SectionLabel>
          <div className="grid md:grid-cols-3 gap-8">
            {rest.map((p, i) => (
              <FadeUp key={p.id} delay={(i % 3) * 0.06}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block border border-white/10 hover:border-wutn transition-colors p-8 h-full">
                  <span className="text-xs uppercase tracking-[0.2em] text-wutn font-bold">{p.category}</span>
                  <h3 className="mt-3 font-display uppercase text-2xl md:text-3xl leading-none group-hover:text-wutn transition-colors">{p.title}</h3>
                  <p className="mt-4 text-zinc-400 text-sm">{p.excerpt}</p>
                  <p className="mt-6 text-xs text-zinc-500">{p.date} · {p.read_time}</p>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
